import React, { useEffect, useRef, useState } from 'react';
import { BsEmojiSmile } from 'react-icons/bs';
import styled from 'styled-components';

import data, { EmojiMartData } from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

// Styled components
const EmojiContainer = styled.span`
  position: relative;
`;

const EmojiButton = styled.button`
  display: flex !important;
  border: none !important;
  padding: 12px !important; /* 0.75rem = 12px */
  border-radius: 9999px !important;
  background-color: transparent !important;
  cursor: pointer !important;
`;

const EmojiIcon = styled(BsEmojiSmile)`
  font-size: 18px !important; /* 1.125rem = 18px */
  color: #6b7280 !important;
`;

const PickerContainer = styled.div`
  position: absolute !important;
  bottom: 40px !important; /* 2.5rem = 40px */
  right: -48px !important; /* -3rem = -48px */
  z-index: 2 !important;
`;

interface EmojiInputProps {
    onEmojiSelect: (emoji: EmojiMartData) => void;
}

const EmojiInput: React.FC<EmojiInputProps> = ({ onEmojiSelect }) => {
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef<HTMLDivElement>(null); // Ref for the emoji picker container

    const togglePicker = () => {
        setShowPicker(!showPicker);
    };

    // Click outside handler
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                pickerRef.current &&
                !pickerRef.current.contains(event.target as Node)
            ) {
                setShowPicker(false);
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Remove the event listener on cleanup
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [pickerRef]);

    return (
        <EmojiContainer>
            <EmojiButton onClick={togglePicker}>
                <EmojiIcon />
            </EmojiButton>
            {showPicker && (
                <PickerContainer ref={pickerRef}>
                    <Picker data={data} onEmojiSelect={onEmojiSelect} />
                </PickerContainer>
            )}
        </EmojiContainer>
    );
};

export default EmojiInput;
